module.exports = __webpack_public_path__ + "media/nomor-urut.f974d5b6.wav";